import { buildTimeUtilizationQueryParams } from './utils'
import { api } from '../../api'

export const timeUtilizationApi = api
  .enhanceEndpoints({
    addTagTypes: ['TimeUtilization'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTimeUtilization: builder.query({
        providesTags: ['TimeUtilization'],
        query: (params) => ({
          url: `/profitability/time?${buildTimeUtilizationQueryParams(params)}`,
          method: 'GET',
        }),
        transformResponse: (response) => response?.data || [],
      }),
      exportTimeUtilizationReport: builder.mutation({
        query: ({ format = 'xlsx', params }) => {
          return {
            url: `/profitability/time/export.${format}`,
            method: 'GET',
            params: buildTimeUtilizationQueryParams(params),
          }
        },
      }),
    }),
  })

export const {
  useLazyGetTimeUtilizationQuery,
  useGetTimeUtilizationQuery,
  useExportTimeUtilizationReportMutation,
} = timeUtilizationApi
